/**
 * Helpers for working with Strapi v5 REST responses.
 * Strapi v5 returns flat entities: { data: {...fields, id, documentId}, meta }.
 */
import { env } from "@/config/env";

const STRAPI_ORIGIN = env.API_URL.replace(/\/api\/?$/, "");

/** Unwrap a single-entity response. */
export const unwrap = (res) => res?.data?.data ?? null;

/** Unwrap a collection response into { items, pagination }. */
export const unwrapList = (res) => ({
  items: res?.data?.data ?? [],
  pagination: res?.data?.meta?.pagination ?? null,
});

/** Extract a human-readable message from a Strapi/Axios error. */
export const getErrorMessage = (error, fallback = "Something went wrong") =>
  error?.response?.data?.error?.message || error?.message || fallback;

/** Absolute URL for a Strapi media file object (or null). */
export const getStrapiMedia = (file) => {
  const url = file?.url;
  if (!url) return null;
  return url.startsWith("http") ? url : `${STRAPI_ORIGIN}${url}`;
};

/** Flatten Strapi "blocks" rich text into plain paragraphs. */
export const blocksToText = (blocks) => {
  if (typeof blocks === "string") return blocks;
  if (!Array.isArray(blocks)) return "";
  return blocks
    .map((block) => (block.children ?? []).map((c) => c.text ?? "").join(""))
    .filter(Boolean)
    .join("\n\n");
};
